import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { AppraisalDetailsV2Store } from '../../../../stores/documentForms/appraisalDetailsV2/appraisalDetailsV2Store';

type Props = {
  store?: AppraisalDetailsV2Store;
};

const useHeaderStyles = makeStyles(theme => ({
  headerSection: {
    backgroundColor: '#FFFFFF',
    padding: '16px 24px',
    borderRadius: '8px',
    marginBottom: '24px',
    boxShadow: '16px 16px 32px 0px rgba(69, 69, 127, 0.08)',
  },
  labelText: {
    fontSize: '14px',
    color: 'rgba(63, 63, 70, 1)',
    fontWeight: 400,
  },
  valueText: {
    fontSize: '18px',
    fontWeight: 600,
    color: 'rgba(0, 0, 7, 1)',
  },
  redDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'red',
    display: 'inline-block',
    verticalAlign: 'top',
  },
}));

export const AppraisalDetailsHeader = observer(({ store }: Props) => {
  const classes = useHeaderStyles();
  const appraisal = store.appraisal;

  return (
    <Box className={classes.headerSection}>
      <Grid container spacing={2} style={{ justifyContent: 'space-between' }}>
        <Grid item>
          <Typography className={classes.labelText}>Loan #</Typography>
          <Typography className={classes.valueText}>
            {appraisal.loanNumber}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.labelText}>Loan Type</Typography>
          <Typography className={classes.valueText}>
            {appraisal.loanType}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.labelText}>Borrower</Typography>
          <Typography className={classes.valueText}>
            {appraisal.borrower}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.labelText}>Payment</Typography>
          <Typography className={classes.valueText}>
            {store.paymentSummary.label}
            {store.paymentSummary.count != null && (
              <>
                {' '}({store.paymentSummary.count}){' '}
                <div className={classes.redDot} />
              </>
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.labelText}>Current AMC</Typography>
          <Typography className={classes.valueText}>
            {appraisal.currentAmc}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
});
